// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"66e7a7f7","548":"a8bf969e","711":"de9c9d99","880":"26ddc962"}[chunkId] + ".chunk.css";
};